import pkg from '../../package.json';

export const environment = {
    firebase: {
        apiKey: 'AIzaSyAe8eZic-GLHd7eLAWkGlId2HXJTQ_Om_I',
        authDomain: 'wasteland-warfare.firebaseapp.com',
        databaseURL: 'https://wasteland-warfare.firebaseio.com',
        projectId: 'wasteland-warfare',
        storageBucket: 'wasteland-warfare.appspot.com',
        messagingSenderId: '280958953804',
        appId: '1:280958953804:web:7d6f97b0fb20b3380607e9'
    },
    production: true,
    apiBaseUrl: '/api',
    appVersion: 'v' + pkg.version,
    // Never true in a build that ships: the mock login bypasses the real credential check, and
    // `config.ts` reads this flag unconditionally. Defined here as well as in `environment.ts`
    // because each build configuration file-replaces that file, and a flag only the dev
    // environment declares fails to compile in every other one.
    enableMockLogin: false
};
